/**
 * Pinned speakers — small localStorage list of favorited speakers that a
 * user wants one-click access to from the sidebar.
 *
 * Emits a `pinned-speakers-change` window event whenever the list mutates so
 * the sidebar can refresh live without prop drilling.
 */

const KEY = 'vaad_pinned_speakers_v1';
const MAX_PINS = 12;
const EVENT_NAME = 'pinned-speakers-change';

const read = () => {
  try {
    const raw = localStorage.getItem(KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
};

const write = (arr) => {
  try {
    localStorage.setItem(KEY, JSON.stringify(arr));
    window.dispatchEvent(new CustomEvent(EVENT_NAME));
  } catch { /* quota */ }
};

export const listPinnedSpeakers = () => read();

export const isSpeakerPinned = (name) => {
  if (!name) return false;
  const key = name.toLowerCase();
  return read().some((s) => s.name && s.name.toLowerCase() === key);
};

export const pinSpeaker = (speaker) => {
  if (!speaker || !speaker.name) return;
  const arr = read().filter(
    (s) => (s.name || '').toLowerCase() !== speaker.name.toLowerCase(),
  );
  arr.unshift({
    name: speaker.name,
    image: speaker.image || null,
    recordings: speaker.recordings ?? speaker.count ?? null,
    pinned_at: Date.now(),
  });
  write(arr.slice(0, MAX_PINS));
};

export const unpinSpeaker = (name) => {
  if (!name) return;
  const arr = read().filter((s) => (s.name || '').toLowerCase() !== name.toLowerCase());
  write(arr);
};

export const toggleSpeakerPin = (speaker) => {
  if (isSpeakerPinned(speaker?.name)) {
    unpinSpeaker(speaker.name);
    return false;
  }
  pinSpeaker(speaker);
  return true;
};

export const pinnedSpeakersChangeEvent = EVENT_NAME;
